import ActivityReceiveIcon from './ActivityReceiveIcon'

export default ActivityReceiveIcon
